export default __webpack_public_path__ + "static/media/kfm_plant_slide.b5c062c3.jpg";